import React from 'react';
import { MailIcon, PencilIcon, PhoneIcon, SendIcon } from 'lucide-react';
import type { Recipient } from '../types/disclosures';
interface RecipientCardProps {
  recipient: Recipient;
  onEdit: (recipient: Recipient) => void;
}
export function RecipientCard({
  recipient,
  onEdit
}: RecipientCardProps) {
  const missingEmail = !recipient.email;
  return <div className="rounded-lg border border-slate-200 bg-white p-4" data-id="element-243" data-mp="1ne62o74j8j1c">
      <div className="flex items-start justify-between gap-3" data-id="element-244" data-mp="1sekf01d62f56">
        <div className="flex items-start gap-3" data-id="element-245" data-mp="1wgfdky3pqef9">
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-slate-100 text-[13px] font-semibold text-slate-600" data-id="element-246" data-mp="1wf4al0i3dap7">
            {recipient.name.split(' ').map(part => part[0]).join('')}
          </span>
          <div className="min-w-0" data-id="element-247" data-mp="2b74qq60qi3lr">
            <p className="text-[14px] font-semibold text-slate-900" data-id="element-248" data-mp="2b40fioouq7ll">{recipient.name}</p>
            <p className="text-[12px] text-slate-500" data-id="element-249" data-mp="2g56db0xdcl1z">{recipient.role}</p>
          </div>
        </div>
        <button type="button" onClick={() => onEdit(recipient)} className="inline-flex items-center gap-1.5 rounded-md px-2 py-1 text-[12px] font-medium text-slate-500 transition hover:bg-slate-50 hover:text-slate-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500" data-id="element-250" data-mp="29gola0yekec3">
          <PencilIcon className="h-3.5 w-3.5" data-id="element-251" data-mp="2s8zl1lxrfw5z" />
          Edit
        </button>
      </div>

      <dl className="mt-3 space-y-1.5 text-[13px]" data-id="element-252" data-mp="2na657mv03t2n">
        <div className="flex items-center gap-2" data-id="element-253" data-mp="2nbh7tjcpmus6">
          <MailIcon className="h-3.5 w-3.5 shrink-0 text-slate-400" aria-hidden="true" data-id="element-254" data-mp="2ijfxi2z3re4s" />
          <dt className="sr-only" data-id="element-255" data-mp="2ih3cti1ympo1">Email</dt>
          <dd className={missingEmail ? 'font-medium text-amber-700' : 'text-slate-600'} data-id="element-256" data-mp="2egt6236cfv84">
            {recipient.email || 'Email address required'}
          </dd>
        </div>
        <div className="flex items-center gap-2" data-id="element-257" data-mp="368igbe5h3d0v">
          <PhoneIcon className="h-3.5 w-3.5 shrink-0 text-slate-400" aria-hidden="true" data-id="element-258" data-mp="367qugv1ogtns" />
          <dt className="sr-only" data-id="element-259" data-mp="14c03oav0kp20">Phone</dt>
          <dd className="text-slate-600" data-id="element-260" data-mp="19al3482fz4pe">{recipient.phone}</dd>
        </div>
        <div className="flex items-center gap-2" data-id="element-261" data-mp="19cnryoruyrsj">
          <SendIcon className="h-3.5 w-3.5 shrink-0 text-slate-400" aria-hidden="true" data-id="element-262" data-mp="umgigyjtwj3z" />
          <dt className="sr-only" data-id="element-263" data-mp="zk9tc4w2u1al">Delivery</dt>
          <dd className="text-slate-600" data-id="element-264" data-mp="ziyp63ypyriy">Delivery: {recipient.delivery}</dd>
        </div>
      </dl>
    </div>;
}